import type { JSONContent } from '@tiptap/core'

import { tagNodeName } from '@/services/forms/tmTiptap/const'

export const hasTags = (docContent: JSONContent) => {
  if (docContent.type === tagNodeName) return true
  if (docContent.content) {
    const hasNestedTags = docContent.content.find((content) => hasTags(content))
    if (hasNestedTags) return true
  }
  return false
}
